module.exports = __webpack_public_path__ + "img/money_black_24dp_dollar.a8eddf6a.svg";